import { Link } from 'react-router-dom';
import { Routes } from '../../utils/Routes';

export default function BackToGalleryLink({
  className = '',
  to = Routes.Art,
  label = 'Back to Gallery',
  dark = false,
}) {
  const colors = dark
    ? 'text-gray-400 hover:text-white'
    : 'text-gray-700 hover:text-blue-600';
  const borderColor = dark
    ? 'group-hover:border-gray-400'
    : 'group-hover:border-blue-500';

  return (
    <div className={`inline-block ${className}`}>
      <Link
        to={to}
        className={`group flex items-center gap-2 bg-transparent transition-colors duration-200 font-light text-sm tracking-widest uppercase focus:outline-none ${colors}`}
        style={{ fontFamily: 'inherit' }}
      >
        <span className="inline-block">
          <svg
            width="16"
            height="16"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.5 15L8 10L12.5 5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
        <span
          className={`border-b border-transparent transition-all duration-200 pb-0.5 ${borderColor}`}
        >
          {label}
        </span>
      </Link>
    </div>
  );
}
